// ============================================
// PANEL ADMIN - SMART SHOP
// ============================================

const BACKEND_URL = 'https://smartshop-admin.smartshop-peru.workers.dev';

let adminProductosCache = [];
let adminPedidosCache = [];
let periodoVentas = 'mes';

// ============================================
// ABRIR / CERRAR
// ============================================
function abrirPanelAdmin() {
  const overlay = document.getElementById('adminPanelOverlay');
  const boton = document.getElementById('adminPanelBtn');
  if (!overlay) return;
  overlay.classList.add('show');
  document.body.style.overflow = 'hidden';
  if (boton) boton.style.display = 'none';
  cambiarTabAdmin('dashboard');
}

function cerrarPanelAdmin() {
  const overlay = document.getElementById('adminPanelOverlay');
  const boton = document.getElementById('adminPanelBtn');
  if (!overlay) return;
  overlay.classList.remove('show');
  document.body.style.overflow = '';
  if (boton) boton.style.display = 'flex';
}

function cambiarTabAdmin(tab) {
  document.querySelectorAll('.admin-tab-content').forEach(el => el.classList.remove('active'));
  document.querySelectorAll('.admin-panel-tab').forEach(el => {
    el.classList.toggle('active', el.dataset.tab === tab);
  });
  const t = document.getElementById('tab-' + tab);
  if (t) t.classList.add('active');

  if (tab === 'dashboard') cargarDashboardStats();
  if (tab === 'productos') cargarProductosAdmin();
  if (tab === 'pedidos') cargarPedidosAdmin();
  if (tab === 'ventas') cargarVentas();
  if (tab === 'clientes') cargarClientesAdmin();
}

// ============================================
// SUBIR IMAGEN AL WORKER
// ============================================
async function subirImagenAWorker(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await fetch(`${BACKEND_URL}/uploadImage`, {
    method: 'POST',
    body: formData
  });

  const data = await res.json();
  if (!data.success) {
    throw new Error(data.error || 'Error al subir imagen');
  }
  console.log('✅ Imagen subida (staging):', data.imageUrl);
  return data.imageUrl;
}

function mostrarNombreArchivo(input) {
  const textElement = input.id === 'adminImagenFile' 
    ? document.getElementById('adminImagenText') 
    : document.getElementById('editImagenText');
    
  if (input.files && input.files.length > 0) {
    if (textElement) textElement.textContent = "📸 " + input.files[0].name;
  } else {
    if (textElement) textElement.textContent = "Elegir imagen de mi galería";
  }
}

// ============================================
// DASHBOARD
// ============================================
async function cargarDashboardStats() {
  try {
    // 🔥 Usamos adminGetProducts para no usar caché
    const res = await fetch(`${BACKEND_URL}/adminGetProducts?t=${Date.now()}`, { cache: 'no-store' });
    const data = await res.json();
    const lista = data.products || [];

    const totalProductos = lista.length;
    const totalStock = lista.reduce((s, p) => s + (parseInt(p.variants.nodes[0].inventoryQuantity) || 0), 0);
    const valorInventario = lista.reduce((s, p) => {
      const v = p.variants.nodes[0];
      return s + ((parseFloat(v.price) || 0) * (parseInt(v.inventoryQuantity) || 0));
    }, 0);
    const agotados = lista.filter(p => (parseInt(p.variants.nodes[0].inventoryQuantity) || 0) === 0).length;
    const stockBajo = lista.filter(p => {
      const s = parseInt(p.variants.nodes[0].inventoryQuantity) || 0;
      return s > 0 && s <= 3;
    }).length;

    document.getElementById('dashboardStats').innerHTML = `
      <div class="admin-stat-card"><span class="admin-stat-icon">📦</span><div class="admin-stat-label">Productos</div><div class="admin-stat-value">${totalProductos}</div></div>
      <div class="admin-stat-card"><span class="admin-stat-icon">📊</span><div class="admin-stat-label">Stock total</div><div class="admin-stat-value">${totalStock}</div></div>
      <div class="admin-stat-card"><span class="admin-stat-icon">💰</span><div class="admin-stat-label">Inventario</div><div class="admin-stat-value">S/${valorInventario.toFixed(0)}</div></div>
      <div class="admin-stat-card"><span class="admin-stat-icon">❌</span><div class="admin-stat-label">Agotados</div><div class="admin-stat-value">${agotados}</div></div>
      <div class="admin-stat-card"><span class="admin-stat-icon">⚠️</span><div class="admin-stat-label">Stock bajo</div><div class="admin-stat-value">${stockBajo}</div></div>
    `;
  } catch (e) { console.error('❌', e); }
}

// ============================================
// PRODUCTOS
// ============================================
async function cargarProductosAdmin() {
  const cont = document.getElementById('adminProductosLista');
  if (!cont) return;
  cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">⏳ Cargando...</p>';

  try {
    // 🔥 Usamos adminGetProducts para evitar el KV
    const res = await fetch(`${BACKEND_URL}/adminGetProducts?t=${Date.now()}`, { cache: 'no-store' });
    const data = await res.json();
    const lista = data.products || [];

    if (lista.length === 0) {
      cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">No hay productos</p>';
      return;
    }

    adminProductosCache = lista;
    renderizarListaProductosAdmin(lista);

    // 🔥 CONECTAR LA LUPA DE BÚSQUEDA
    const inputBuscar = document.getElementById('adminBuscarProducto');
    if (inputBuscar && !inputBuscar.dataset.enganchado) {
      inputBuscar.dataset.enganchado = 'true';
      inputBuscar.addEventListener('input', function() {
        const q = this.value.toLowerCase().trim();
        if (!q) { renderizarListaProductosAdmin(lista); return; }
        const filtrados = lista.filter(p =>
          (p.title || '').toLowerCase().includes(q) ||
          (p.variants.nodes[0].sku || '').toLowerCase().includes(q)
        );
        renderizarListaProductosAdmin(filtrados);
      });
    }

  } catch (e) {
    console.error('❌', e);
    cont.innerHTML = '<p style="color:#ff6b6b;text-align:center;">❌ Error al cargar productos</p>';
  }
}

function renderizarListaProductosAdmin(lista) {
  const cont = document.getElementById('adminProductosLista');
  if (!cont) return;

  if (lista.length === 0) {
    cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">No hay productos que coincidan</p>';
    return;
  }

  let html = '';
  lista.forEach(p => {
    const variante = p.variants.nodes[0];
    const stock = parseInt(variante.inventoryQuantity) || 0;
    const precio = parseFloat(variante.price) || 0;
    const precioOld = parseFloat(variante.compareAtPrice) || 0;
    const tieneDescuento = precioOld > 0 && precioOld > precio;
    const pct = tieneDescuento ? Math.round(((precioOld - precio) / precioOld) * 100) : 0;
    const imagen = p.featuredImage ? p.featuredImage.url : '';
    const clase = stock === 0 ? 'out' : (stock <= 3 ? 'low' : 'ok');

    const productId = p.id;
    const variantId = variante.id;
    const titulo = (p.title || '').replace(/"/g, '&quot;').replace(/'/g, "\\'");
    const descripcion = (p.descriptionHtml || '').replace(/"/g, '&quot;').replace(/'/g, "\\'").replace(/\n/g, ' ');
    const estado = p.status || 'ACTIVE';

    html += `
      <div class="admin-product-item">
        <div class="admin-product-header">
          <img src="${imagen}" class="admin-product-img" loading="lazy" onerror="this.src='data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 60 60%22%3E%3Crect width=%2260%22 height=%2260%22 fill=%22%231a0b1a%22/%3E%3Ctext x=%2230%22 y=%2235%22 font-size=%2224%22 text-anchor=%22middle%22 fill=%22%23d4af37%22%3E%3F%3C/text%3E%3C/svg%3E';">
          <div class="admin-product-info">
            <div class="admin-product-name">
              ${p.title || 'Sin nombre'}
              ${tieneDescuento ? `<span style="color:#4ade80;font-size:10px;margin-left:6px;">-${pct}%</span>` : ''}
            </div>
            <div class="admin-product-price">
              S/ ${precio.toFixed(2)}
              ${tieneDescuento ? `<span style="color:rgba(240,236,228,0.3);text-decoration:line-through;font-size:11px;margin-left:6px;">S/ ${precioOld.toFixed(2)}</span>` : ''}
            </div>
          </div>
          <span class="admin-product-stock ${clase}">${stock} uds</span>
        </div>
        <div class="admin-stock-controls">
          <input type="number" id="stock-${variantId}" class="admin-stock-input" value="${stock}" min="0">
          <button class="admin-icon-btn" onclick="guardarStockManual('${variantId}', '${productId}')" title="Guardar stock">💾</button>
          <button class="admin-icon-btn" onclick="abrirEditarProducto('${productId}', '${variantId}', '${titulo}', '${descripcion}', ${precio}, ${precioOld}, '${estado}', ${stock})" title="Editar producto" style="background:rgba(93,173,226,0.15);border-color:rgba(93,173,226,0.4);color:#5dade2;">✏️</button>
          <button class="admin-icon-btn" onclick="abrirDescuentoProducto('${productId}', '${variantId}', '${titulo}', ${precio})" title="Editar descuento" style="background:rgba(212,175,55,0.15);border-color:rgba(212,175,55,0.4);color:#d4af37;">🏷️</button>
          <button class="admin-icon-btn danger" onclick="eliminarProducto('${productId}', '${(p.title || '').replace(/'/g, "\\'")}')" title="Eliminar producto" style="margin-left:auto;">🗑️</button>
        </div>
      </div>
    `;
  });
  cont.innerHTML = html;
}

// 🔥 ARREGLADO: ENVÍA EL PRODUCT ID TAMBIÉN
async function guardarStockManual(variantId, productId) {
  try {
    const input = document.getElementById('stock-' + variantId);
    if (!input) return;
    const stock = Math.max(0, parseInt(input.value) || 0);

    const res = await fetch(`${BACKEND_URL}/updateStock`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ variantId, productId, newStock: stock })
    });
    const data = await res.json();
    if (data.success) {
      alert('✅ Stock actualizado');
      cargarProductosAdmin();
      cargarDashboardStats();
    } else {
      alert('❌ ' + data.error);
    }
  } catch (e) { console.error('❌', e); }
}

// ============================================
// EDITAR PRODUCTO
// ============================================
function abrirEditarProducto(productId, variantId, titulo, descripcion, precio, precioOld, estado, stock) {
  let modal = document.getElementById('modal-editar-producto');
  if (modal) modal.remove();

  modal = document.createElement('div');
  modal.id = 'modal-editar-producto';
  modal.className = 'admin-panel-overlay show';
  modal.style.zIndex = '10001';
  modal.innerHTML = `
    <div class="admin-panel" style="max-width: 600px;">
      <div class="admin-panel-header">
        <div class="admin-panel-title">
          <span class="admin-crown">✏️</span>
          <div><h2>Editar producto</h2><p>Modifica los datos</p></div>
        </div>
        <button class="admin-panel-close" onclick="document.getElementById('modal-editar-producto').remove()">✕</button>
      </div>
      <div class="admin-panel-body" style="max-height: 75vh; overflow-y: auto;">
        
        <div class="admin-form-group">
          <label class="admin-label">📦 Título</label>
          <input type="text" id="edit-titulo" class="admin-input" value="${titulo}">
        </div>

        <div class="admin-form-group">
          <label class="admin-label">📝 Descripción</label>
          <textarea id="edit-descripcion" class="admin-input" rows="4" maxlength="3000" style="resize:vertical;">${descripcion}</textarea>
        </div>

        <div class="admin-form-row">
          <div class="admin-form-group">
            <label class="admin-label">💰 Precio</label>
            <input type="number" id="edit-precio" class="admin-input" value="${precio}" step="0.01" min="0">
          </div>
          <div class="admin-form-group">
            <label class="admin-label">💸 Precio oferta</label>
            <input type="number" id="edit-precio-old" class="admin-input" value="${precioOld || ''}" step="0.01" min="0">
          </div>
        </div>

        <div class="admin-form-row">
          <div class="admin-form-group">
            <label class="admin-label">📊 Stock</label>
            <input type="number" id="edit-stock" class="admin-input" value="${stock}" min="0">
          </div>
          <div class="admin-form-group">
            <label class="admin-label">📌 Estado</label>
            <select id="edit-estado" class="admin-input">
              <option value="ACTIVE" ${estado === 'ACTIVE' ? 'selected' : ''}>✅ Activo</option>
              <option value="DRAFT" ${estado === 'DRAFT' ? 'selected' : ''}>📝 Borrador</option>
            </select>
          </div>
        </div>

        <div class="admin-form-group">
          <label class="admin-label">📸 Cambiar imagen (opcional)</label>
          <div class="admin-file-upload-wrapper" onclick="document.getElementById('editImagenFile').click()">
            <input type="file" id="editImagenFile" accept="image/*" style="display: none;" onchange="mostrarNombreArchivo(this)">
            <span class="admin-file-icon">📁</span>
            <span class="admin-file-text" id="editImagenText">Elegir nueva imagen</span>
          </div>
        </div>

        <button class="admin-btn admin-btn-primary admin-btn-full" onclick="guardarEditarProducto('${productId}', '${variantId}')">✅ Guardar cambios</button>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
}

async function guardarEditarProducto(productId, variantId) {
  const titulo = document.getElementById('edit-titulo').value.trim();
  const descripcion = document.getElementById('edit-descripcion').value.trim();
  const precio = parseFloat(document.getElementById('edit-precio').value);
  const precioOld = parseFloat(document.getElementById('edit-precio-old').value) || null;
  const stock = parseInt(document.getElementById('edit-stock').value) || 0;
  const estado = document.getElementById('edit-estado').value;

  if (!titulo || !precio) {
    alert('⚠️ Título y precio son obligatorios');
    return;
  }

  try {
    let imageUrl = null;
    
    // 🔥 AQUÍ ESTÁ LA MAGIA: Revisamos si se seleccionó una imagen nueva
    const fileInput = document.getElementById('editImagenFile');
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      console.log('📸 Subiendo nueva imagen...');
      imageUrl = await subirImagenAWorker(file); // Usa la función que ya tienes
      console.log('✅ Imagen subida:', imageUrl);
    }

    const bodyData = {
      productId,
      variantId,
      title: titulo,
      descriptionHtml: descripcion,
      price: precio,
      compareAtPrice: precioOld,
      stock: stock,
      status: estado,
      imageUrl: imageUrl // 👈 Enviamos la URL de la nueva imagen
    };

    const res = await fetch(`${BACKEND_URL}/updateProduct`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(bodyData)
    });

    const data = await res.json();

    if (data.success) {
      alert('✅ Producto actualizado');
      document.getElementById('modal-editar-producto').remove();
      await new Promise(r => setTimeout(r, 2000));
      cargarProductosAdmin();
      cargarDashboardStats();
    } else {
      alert('❌ ' + data.error);
    }
  } catch (e) {
    console.error('❌', e);
    alert('❌ Error al guardar: ' + e.message);
  }
}

// ============================================
// AGREGAR PRODUCTO
// ============================================
async function guardarProducto() {
  const nombre = document.getElementById('adminNombre').value.trim();
  const precio = parseFloat(document.getElementById('adminPrecio').value);
  const precioOld = parseFloat(document.getElementById('adminPrecioOld').value) || null;
  const descripcion = document.getElementById('adminDescripcion').value.trim();
  const stock = parseInt(document.getElementById('adminStock').value) || 0;
  
  const fileInput = document.getElementById('adminImagenFile');
  const file = fileInput ? fileInput.files[0] : null;

  if (!nombre || !precio) {
    alert('⚠️ Nombre y precio son obligatorios');
    return;
  }

  try {
    let imageUrl = null;
    if (file) {
      imageUrl = await subirImagenAWorker(file);
    }

    const res = await fetch(`${BACKEND_URL}/createProduct`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        title: nombre,
        descriptionHtml: descripcion || 'Producto premium',
        price: precio,
        compareAtPrice: precioOld,
        imageUrl: imageUrl,
        stock: stock
      })
    });

    const data = await res.json();

    if (data.success) {
      alert('✅ Producto agregado');
      ['adminNombre','adminPrecio','adminPrecioOld','adminDescripcion','adminStock'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.value = '';
      });
      if (fileInput) {
        fileInput.value = '';
        const textEl = document.getElementById('adminImagenText');
        if (textEl) textEl.textContent = 'Elegir imagen de mi galería';
      }
      await new Promise(r => setTimeout(r, 2000));
      cargarProductosAdmin();
      cargarDashboardStats();
    } else {
      alert('❌ ' + data.error);
    }
  } catch (e) {
    console.error('❌', e);
    alert('❌ Error al guardar: ' + e.message);
  }
}

// ============================================
// ELIMINAR PRODUCTO
// ============================================
async function eliminarProducto(productId, nombre) {
  if (!confirm(`¿Eliminar "${nombre}"?\n\nEsta acción no se puede deshacer.`)) return;

  try {
    const res = await fetch(`${BACKEND_URL}/deleteProduct`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId })
    });

    const data = await res.json();

    if (data.success) {
      alert('✅ Producto eliminado');
      cargarProductosAdmin();
      cargarDashboardStats();
    } else {
      alert('❌ ' + data.error);
    }
  } catch (e) {
    console.error('❌', e);
    alert('❌ Error al eliminar');
  }
}

// ============================================
// PEDIDOS
// ============================================
async function cargarPedidosAdmin() {
  const cont = document.getElementById('adminPedidosLista');
  if (!cont) return;
  cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">⏳ Cargando...</p>';

  try {
    const res = await fetch(`${BACKEND_URL}/getOrders?t=${Date.now()}`, { cache: 'no-store' });
    const data = await res.json();
    const pedidos = data.orders || [];

    if (pedidos.length === 0) {
      cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">No hay pedidos</p>';
      return;
    }

    adminPedidosCache = pedidos;
    renderizarListaPedidos(pedidos);
  } catch (e) {
    console.error('❌', e);
    cont.innerHTML = '<p style="color:#ff6b6b;text-align:center;">❌ Error</p>';
  }
}

function renderizarListaPedidos(lista) {
  const cont = document.getElementById('adminPedidosLista');
  if (!cont) return;

  let html = `<h4 style="color:#d4af37;margin-bottom:10px;font-family:Georgia,serif;">📋 ${lista.length} pedido(s)</h4>`;
  lista.forEach(p => {
    const est = p.displayFinancialStatus || 'PENDIENTE';
    const fecha = p.createdAt ? new Date(p.createdAt).toLocaleDateString('es-PE', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : 'Sin fecha';
    const total = parseFloat(p.totalPriceSet.shopMoney.amount) || 0;

    let colorEst = '#fbbf24', emojiEst = '⏳';
    if (est === 'PAID') { colorEst = '#4ade80'; emojiEst = '✅'; }
    if (est === 'REFUNDED' || est === 'VOIDED') { colorEst = '#ff6b6b'; emojiEst = '❌'; }
    if (p.displayFulfillmentStatus === 'FULFILLED') { emojiEst = '🚚'; colorEst = '#5dade2'; }

    let prodHtml = '';
    if (p.lineItems && p.lineItems.nodes) {
      p.lineItems.nodes.forEach(pr => { prodHtml += `<div style="font-size:11px;color:rgba(240,236,228,0.7);padding:2px 0;">• ${pr.title} x ${pr.quantity}</div>`; });
    }

    const dir = p.shippingAddress || {};
    const dirHtml = dir.address1 ? `
      <div style="background:rgba(0,0,0,0.3);border-radius:8px;padding:8px;margin-bottom:10px;">
        <div style="font-size:11px;color:#d4af37;margin-bottom:4px;">📍 Dirección de envío:</div>
        <div style="font-size:11px;color:rgba(240,236,228,0.8);">${dir.name || ''}</div>
        <div style="font-size:11px;color:rgba(240,236,228,0.8);">${dir.address1 || ''}</div>
        <div style="font-size:11px;color:rgba(240,236,228,0.8);">${dir.city || ''}, ${dir.province || ''}</div>
        <div style="font-size:11px;color:rgba(240,236,228,0.8);">${dir.country || ''}</div>
        ${dir.phone ? `<div style="font-size:11px;color:rgba(240,236,228,0.8);">📞 ${dir.phone}</div>` : ''}
      </div>
    ` : '';

    html += `
      <div class="admin-pedido-item" style="border-left:4px solid ${colorEst};">
        <div style="display:flex;justify-content:space-between;align-items:start;margin-bottom:10px;">
          <div>
            <div style="color:#f0ece4;font-weight:700;font-size:13px;">👤 ${p.customer?.displayName || 'Cliente'}</div>
            <div style="font-size:10px;color:rgba(240,236,228,0.4);">${p.customer?.email || ''}</div>
            <div style="font-size:10px;color:rgba(240,236,228,0.4);">${fecha}</div>
          </div>
          <div style="text-align:right;">
            <span style="background:${colorEst}22;color:${colorEst};padding:4px 10px;border-radius:12px;font-size:10px;font-weight:700;">${emojiEst} ${est}</span>
            <div style="color:#d4af37;font-weight:800;font-size:14px;margin-top:4px;">S/ ${total.toFixed(2)}</div>
          </div>
        </div>
        ${dirHtml}
        <div style="background:rgba(0,0,0,0.3);border-radius:8px;padding:8px;margin-bottom:10px;">${prodHtml}</div>
        <div style="display:flex;gap:6px;flex-wrap:wrap;">
          <button class="admin-btn admin-btn-sm admin-btn-success" onclick="cambiarEstadoPedido('${p.id}', 'paid')">✅ Pagado</button>
          <button class="admin-btn admin-btn-sm admin-btn-secondary" onclick="cambiarEstadoPedido('${p.id}', 'shipped')">🚚 Enviado</button>
          <button class="admin-btn admin-btn-sm admin-btn-danger" onclick="cambiarEstadoPedido('${p.id}', 'cancelled')">❌ Cancelar</button>
        </div>
      </div>
    `;
  });
  cont.innerHTML = html;
}

async function cambiarEstadoPedido(orderId, action) {
  const textos = {
    paid: '¿Marcar este pedido como PAGADO?',
    shipped: '¿Marcar este pedido como ENVIADO?',
    cancelled: '¿CANCELAR este pedido? Esta acción no se puede deshacer.'
  };
  if (!confirm(textos[action])) return;

  try {
    const res = await fetch(`${BACKEND_URL}/updateOrderStatus`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderId, action })
    });
    const data = await res.json();
    if (data.success) {
      const mensajes = { paid: '✅ Pedido marcado como pagado', shipped: '🚚 Pedido marcado como enviado', cancelled: '❌ Pedido cancelado' };
      alert(mensajes[action]);
      setTimeout(() => { cargarPedidosAdmin(); }, 2000);
    } else {
      alert('❌ ' + (data.error || 'Error al actualizar'));
    }
  } catch (e) { console.error('❌', e); alert('❌ Error al conectar'); }
}

// ============================================
// VENTAS
// ============================================
async function cargarVentas() {
  try {
    const res = await fetch(`${BACKEND_URL}/getOrders?t=${Date.now()}`, { cache: 'no-store' });
    const data = await res.json();
    const todos = data.orders || [];

    const ahora = new Date();
    let desde;
    if (periodoVentas === 'dia') desde = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());
    else if (periodoVentas === 'semana') desde = new Date(ahora.getTime() - 7 * 24 * 60 * 60 * 1000);
    else if (periodoVentas === 'mes') desde = new Date(ahora.getFullYear(), ahora.getMonth(), 1);
    else desde = new Date(0);

    const pedidos = todos.filter(p => p.createdAt && new Date(p.createdAt) >= desde);
    const totalV = pedidos.reduce((s, p) => s + (parseFloat(p.totalPriceSet.shopMoney.amount) || 0), 0);
    const numPed = pedidos.length;
    const ticket = numPed > 0 ? totalV / numPed : 0;

    const nomPer = { dia: 'Hoy', semana: 'Últimos 7 días', mes: 'Este mes', todo: 'Todo el tiempo' };

    document.getElementById('ventasResumen').innerHTML = `
      <div style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:14px;">
        <button class="admin-btn admin-btn-sm ${periodoVentas==='dia'?'admin-btn-primary':'admin-btn-secondary'}" onclick="cambiarPeriodoVentas('dia')">📅 Día</button>
        <button class="admin-btn admin-btn-sm ${periodoVentas==='semana'?'admin-btn-primary':'admin-btn-secondary'}" onclick="cambiarPeriodoVentas('semana')">📅 Semana</button>
        <button class="admin-btn admin-btn-sm ${periodoVentas==='mes'?'admin-btn-primary':'admin-btn-secondary'}" onclick="cambiarPeriodoVentas('mes')">📅 Mes</button>
        <button class="admin-btn admin-btn-sm ${periodoVentas==='todo'?'admin-btn-primary':'admin-btn-secondary'}" onclick="cambiarPeriodoVentas('todo')">📅 Todo</button>
      </div>
      <p style="font-size:11px;color:rgba(240,236,228,0.5);margin-bottom:12px;">📅 ${nomPer[periodoVentas]}</p>
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(140px,1fr));gap:12px;">
        <div class="admin-stat-card"><span class="admin-stat-icon">💰</span><div class="admin-stat-label">Total vendido</div><div class="admin-stat-value">S/${totalV.toFixed(2)}</div></div>
        <div class="admin-stat-card"><span class="admin-stat-icon">📦</span><div class="admin-stat-label">Pedidos</div><div class="admin-stat-value">${numPed}</div></div>
        <div class="admin-stat-card"><span class="admin-stat-icon">💵</span><div class="admin-stat-label">Ticket prom.</div><div class="admin-stat-value">S/${ticket.toFixed(2)}</div></div>
      </div>
    `;
  } catch (e) { console.error('❌ ventas:', e); }
}

function cambiarPeriodoVentas(periodo) {
  periodoVentas = periodo;
  cargarVentas();
}

// ============================================
// CLIENTES
// ============================================
async function cargarClientesAdmin() {
  const cont = document.getElementById('adminClientesLista');
  if (!cont) return;
  cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">⏳ Cargando...</p>';

  try {
    const res = await fetch(`${BACKEND_URL}/getCustomers?t=${Date.now()}`, { cache: 'no-store' });
    const data = await res.json();
    const lista = data.customers || [];

    if (lista.length === 0) {
      cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">No hay clientes aún</p>';
      return;
    }

    renderizarListaClientes(lista);

    const inputBuscar = document.getElementById('adminBuscarCliente');
    if (inputBuscar && !inputBuscar.dataset.enganchado) {
      inputBuscar.dataset.enganchado = 'true';
      inputBuscar.addEventListener('input', function() {
        const q = this.value.toLowerCase().trim();
        if (!q) { renderizarListaClientes(lista); return; }
        const filtrados = lista.filter(c =>
          (c.displayName || '').toLowerCase().includes(q) ||
          (c.email || '').toLowerCase().includes(q) ||
          (c.phone || '').toLowerCase().includes(q)
        );
        renderizarListaClientes(filtrados);
      });
    }
  } catch (e) {
    console.error('❌', e);
    cont.innerHTML = '<p style="color:#ff6b6b;text-align:center;">❌ Error al cargar clientes</p>';
  }
}

function renderizarListaClientes(lista) {
  const cont = document.getElementById('adminClientesLista');
  if (!cont) return;

  if (lista.length === 0) {
    cont.innerHTML = '<p style="text-align:center;color:rgba(212,175,55,0.4);padding:20px;">No hay clientes que coincidan</p>';
    return;
  }

  let html = `<h4 style="color:#d4af37;margin-bottom:10px;font-family:Georgia,serif;">👥 ${lista.length} cliente(s)</h4>`;

  lista.forEach(c => {
    const fecha = c.createdAt ? new Date(c.createdAt).toLocaleDateString('es-PE', { day: '2-digit', month: 'short', year: 'numeric' }) : 'Sin fecha';
    const numPedidos = parseInt(c.numberOfOrders) || 0;
    const totalGastado = c.amountSpent ? parseFloat(c.amountSpent.amount) : 0;
    const telefono = c.phone || (c.defaultAddress ? c.defaultAddress.phone : '') || '';
    const telefonoLimpio = telefono.replace(/\D/g, '');

    const dir = c.defaultAddress || {};
    const dirTexto = dir.address1 ? `${dir.address1}${dir.address2 ? ', ' + dir.address2 : ''}, ${dir.city || ''}${dir.city && dir.country ? ', ' : ''}${dir.country || ''}` : 'Sin dirección';
    const inicial = (c.displayName || 'C').charAt(0).toUpperCase();

    html += `
      <div class="admin-product-item">
        <div class="admin-product-header">
          <div style="width:50px;height:50px;border-radius:50%;background:linear-gradient(135deg,#8b7526,#d4af37,#f5e6a8);display:flex;align-items:center;justify-content:center;font-weight:900;color:#1a0b1a;font-size:1.2rem;flex-shrink:0;">${inicial}</div>
          <div class="admin-product-info">
            <div class="admin-product-name">${c.displayName || 'Sin nombre'}</div>
            <div style="font-size:11px;color:rgba(240,236,228,0.6);margin-top:2px;">📧 ${c.email || 'Sin email'}</div>
            ${telefono ? `<div style="font-size:11px;color:rgba(240,236,228,0.6);margin-top:2px;">📞 ${telefono}</div>` : ''}
            <div style="font-size:10px;color:rgba(240,236,228,0.4);margin-top:4px;">📅 Cliente desde: ${fecha}</div>
          </div>
          <div style="text-align:right;">
            <div style="color:#4ade80;font-size:11px;font-weight:700;">${numPedidos} pedido(s)</div>
            <div style="color:#d4af37;font-weight:800;font-size:13px;margin-top:4px;">S/ ${totalGastado.toFixed(2)}</div>
          </div>
        </div>
        <div style="background:rgba(0,0,0,0.3);border-radius:8px;padding:8px;margin-top:8px;margin-bottom:10px;">
          <div style="font-size:11px;color:#d4af37;margin-bottom:2px;">📍 Dirección:</div>
          <div style="font-size:11px;color:rgba(240,236,228,0.7);">${dirTexto}</div>
        </div>
        <div class="admin-stock-controls">
          ${telefonoLimpio ? `<a href="https://wa.me/${telefonoLimpio}" target="_blank" rel="noopener" class="admin-btn admin-btn-sm admin-btn-success" style="text-decoration:none;">💬 WhatsApp</a>` : ''}
          ${c.email ? `<a href="mailto:${c.email}" class="admin-btn admin-btn-sm admin-btn-secondary" style="text-decoration:none;">📧 Email</a>` : ''}
          <button class="admin-btn admin-btn-sm admin-btn-danger" onclick="eliminarCliente('${c.id}', '${(c.displayName || '').replace(/'/g, "\\'")}')" style="margin-left:auto;">🗑️ Eliminar</button>
        </div>
      </div>
    `;
  });

  cont.innerHTML = html;
}

// ============================================
// ELIMINAR CLIENTE
// ============================================
async function eliminarCliente(customerId, nombre) {
  if (!confirm(`¿Eliminar al cliente "${nombre}"?`)) return;

  try {
    const res = await fetch(`${BACKEND_URL}/deleteCustomer`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId })
    });
    const data = await res.json();
    if (data.success) {
      alert('✅ Cliente eliminado');
      cargarClientesAdmin();
    } else {
      alert('❌ ' + (data.error || 'Error'));
    }
  } catch (e) { console.error('❌', e); alert('❌ Error'); }
}

// ============================================
// EDITAR DESCUENTO
// ============================================
function abrirDescuentoProducto(productId, variantId, titulo, precioActual) {
  let modal = document.getElementById('modal-descuento-producto');
  if (modal) modal.remove();

  modal = document.createElement('div');
  modal.id = 'modal-descuento-producto';
  modal.className = 'admin-panel-overlay show';
  modal.style.zIndex = '10001';
  
  modal.innerHTML = `
    <div class="admin-panel" style="max-width: 450px;">
      <div class="admin-panel-header" style="background: linear-gradient(135deg, rgba(212,175,55,0.1), rgba(0,0,0,0));">
        <div class="admin-panel-title">
          <span class="admin-crown" style="font-size:1.5rem;">🏷️</span>
          <div>
            <h2 style="font-size:1.2rem; text-transform:uppercase; letter-spacing:1px; margin-bottom:2px;">Descuento</h2>
            <p style="color:rgba(212,175,55,0.6); font-size:10px; letter-spacing:2px;">${titulo}</p>
          </div>
        </div>
        <button class="admin-panel-close" onclick="document.getElementById('modal-descuento-producto').remove()">✕</button>
      </div>
      <div class="admin-panel-body" style="padding: 24px;">
        <div style="background:rgba(0,0,0,0.4); border:1px solid rgba(212,175,55,0.15); border-radius:12px; padding:16px; text-align:center; margin-bottom:24px;">
          <div style="font-size:11px; color:rgba(240,236,228,0.6); margin-bottom:4px;">Precio actual</div>
          <div style="font-size:1.8rem; font-weight:900; color:#d4af37; font-family:Georgia,serif;">S/ ${precioActual.toFixed(2)}</div>
        </div>
        <div class="admin-form-group">
          <label class="admin-label" style="color:#4ade80; font-size:10px; letter-spacing:1px;">💸 PORCENTAJE DE DESCUENTO (%)</label>
          <input type="number" id="desc-porcentaje" class="admin-input" placeholder="Ej: 20" min="1" max="99" oninput="calcularDescuento(${precioActual})">
        </div>
        <div style="text-align:center; color:rgba(240,236,228,0.4); margin:12px 0; font-size:12px;">— O —</div>
        <div class="admin-form-group">
          <label class="admin-label" style="color:#d4af37; font-size:10px; letter-spacing:1px;">🔥 PRECIO CON DESCUENTO (S/)</label>
          <input type="number" id="desc-precio-final" class="admin-input" placeholder="Ej: 24.00" min="0" step="0.01" oninput="calcularPorcentaje(${precioActual})">
        </div>
        <button class="admin-btn admin-btn-primary admin-btn-full" style="margin-top:20px; padding:14px; font-size:13px;" onclick="guardarDescuento('${productId}', '${variantId}', ${precioActual})">💾 Guardar descuento</button>
      </div>
    </div>
  `;
  document.body.appendChild(modal);
}

function calcularDescuento(precioOriginal) {
  const pct = parseFloat(document.getElementById('desc-porcentaje').value);
  const inputPrecio = document.getElementById('desc-precio-final');
  if (!isNaN(pct) && pct > 0 && pct < 100) {
    inputPrecio.value = (precioOriginal - (precioOriginal * (pct / 100))).toFixed(2);
  } else {
    inputPrecio.value = '';
  }
}

function calcularPorcentaje(precioOriginal) {
  const nuevoPrecio = parseFloat(document.getElementById('desc-precio-final').value);
  const inputPct = document.getElementById('desc-porcentaje');
  if (!isNaN(nuevoPrecio) && nuevoPrecio >= 0 && nuevoPrecio < precioOriginal) {
    inputPct.value = Math.round(((precioOriginal - nuevoPrecio) / precioOriginal) * 100);
  } else {
    inputPct.value = '';
  }
}

async function guardarDescuento(productId, variantId, precioOriginal) {
  const nuevoPrecio = parseFloat(document.getElementById('desc-precio-final').value);
  if (isNaN(nuevoPrecio) || nuevoPrecio < 0) { alert('⚠️ Precio inválido'); return; }
  if (nuevoPrecio >= precioOriginal) { alert('⚠️ El precio de oferta debe ser menor'); return; }

  try {
    const res = await fetch(`${BACKEND_URL}/updateProduct`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        productId,
        variantId,
        price: nuevoPrecio,
        compareAtPrice: precioOriginal
      })
    });
    const data = await res.json();
    if (data.success) {
      alert('✅ Descuento aplicado');
      document.getElementById('modal-descuento-producto').remove();
      cargarProductosAdmin();
      cargarDashboardStats();
    } else {
      alert('❌ ' + data.error);
    }
  } catch (e) { console.error('❌', e); alert('❌ Error'); }
}

// ============================================
// EXPORTAR
// ============================================
window.abrirPanelAdmin = abrirPanelAdmin;
window.cerrarPanelAdmin = cerrarPanelAdmin;
window.cambiarTabAdmin = cambiarTabAdmin;
window.cargarProductosAdmin = cargarProductosAdmin;
window.guardarStockManual = guardarStockManual;
window.abrirEditarProducto = abrirEditarProducto;
window.guardarEditarProducto = guardarEditarProducto;
window.guardarProducto = guardarProducto;
window.eliminarProducto = eliminarProducto;
window.cargarPedidosAdmin = cargarPedidosAdmin;
window.cambiarEstadoPedido = cambiarEstadoPedido;
window.cargarVentas = cargarVentas;
window.cambiarPeriodoVentas = cambiarPeriodoVentas;
window.cargarClientesAdmin = cargarClientesAdmin;
window.eliminarCliente = eliminarCliente;
window.abrirDescuentoProducto = abrirDescuentoProducto;
window.calcularDescuento = calcularDescuento;
window.calcularPorcentaje = calcularPorcentaje;
window.guardarDescuento = guardarDescuento;
window.mostrarNombreArchivo = mostrarNombreArchivo;